import React, {
  useState,
  useEffect,
  useRef
} from 'react';
import Service from '../../../../../../../apiService';
import '../../../../../form.css';
import Perbaikan from './Perbaikan';

const FormPerbaikan = ({
  existingPenilaian,
  idPendaftaran,
  setStep,
  isShow,
}) => {
  const contentRef = useRef();
  const [results, setResults] = useState('');
  const [question, setquestions] = useState('');

  const getPenilaian = async (dataArgs) => {
    try {
      const response = await Service.get(`/department/penilaian/trx/${dataArgs}`);
      if (response) {
        setResults(response.data);
        console.log(response.data);
      }
    } catch (error) {
      setResults('');
    }
  };

  useEffect(() => {
    if (idPendaftaran) getPenilaian(idPendaftaran);
  }, [idPendaftaran]);

  return (
    isShow && ( <
      >
      <
      span className = 'text-primary mb-3 d-inline-block'
      style = {
        {
          cursor: 'pointer'
        }
      }
      onClick = {
        () => {
          setStep(1);
          // setIsProgressHidden(false);
        }
      } >
      <
      i className = 'ni ni-curved-next mr-2'
      style = {
        {
          transform: 'scaleX(-1)'
        }
      }
      /> <
      span className = 'd-inline' > Kembali < /span> < /
      span > <
      Perbaikan data = {
        results.details || []
      }
      idPendaftaran = {
        idPendaftaran
      }
      handleSubmit = {
        () => {}
      }
      /> < / >
    )
  );
};

export default FormPerbaikan;